import { defineStore } from 'pinia'

type UnseenActivityResponse = {
    count: number
    bucketActivity: Record<string, 'new' | 'changed'>
    contentActivity: Record<string, 'new' | 'changed'>
}

export const useActivityStore = defineStore('activity', {
    state: () => ({
        unseenCount: 0,
        unseenBucketActivity: {} as Record<string, 'new' | 'changed'>,
        unseenContentActivity: {} as Record<string, 'new' | 'changed'>,
        unseenLoaded: false,
        unseenLoading: false,
    }),
    actions: {
        async fetchUnseenCount() {
            if (this.unseenLoading) return
            this.unseenLoading = true
            try {
                const response = await $fetch<ApiResponse<UnseenActivityResponse>>('/api/activity/unseen-count')
                if (!response.success) throw new Error(response.message)
                this.unseenCount = response.data.count
                this.unseenBucketActivity = response.data.bucketActivity
                this.unseenContentActivity = response.data.contentActivity
                this.unseenLoaded = true
            } finally {
                this.unseenLoading = false
            }
        },
        async markScopeSeen(scope: ActivitySeenScope) {
            const response = await $fetch<ApiResponse<unknown>>('/api/activity/seen', { method: 'POST', body: scope })
            if (!response.success) throw new Error(response.message)
            await this.fetchUnseenCount()
        },
        markSeen() {
            this.unseenCount = 0
            this.unseenBucketActivity = {}
            this.unseenContentActivity = {}
            this.unseenLoaded = true
        },
    },
})
